import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

const useInitialDamageTypeFields = (tabValue: number) => {
  const initialDamageTypeFieldsRef = useRef<{
    tabValue?: number
    damageTypes?: Record<string, string>
  }>({})
  const { t } = useTranslation()
  if (tabValue !== initialDamageTypeFieldsRef.current?.tabValue) {
    const damageInitialTypes = {
      brandgat: t('damage_types.burn_hole'),
      deuk: t('damage_types.dent'),
      gat: t('damage_types.hole'),
      gebroken_afgebroken: t('damage_types.broken'),
      geen_schade: t('damage_types.no_damage'),
      geforceerd: t('damage_types.forced'),
      hagelschade: t('damage_types.hail_damage'),
      hangt_los: t('damage_types.hangs_loose'),
      kras: t('damage_types.scratch'),
      ontbreekt: t('damage_types.is_missing'),
      total_loss: t('damage_types.totaled'),
      waterschade: t('damage_types.water_damage'),
      ...(tabValue === 0
        ? { vlekken: t('damage_types.stains') }
        : { ruitschade: t('damage_types.window_damage') }),
    }

    initialDamageTypeFieldsRef.current.tabValue = tabValue
    initialDamageTypeFieldsRef.current.damageTypes = damageInitialTypes
  }

  return initialDamageTypeFieldsRef.current.damageTypes
}

export default useInitialDamageTypeFields
